import { Factory } from "lucide-react";
import { useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import { Dimmer, Loader } from "semantic-ui-react";
import { useGetProcessData, useGetWasteData } from "../../../api/bestPractice/bestPractice";
import { DropDown } from "../../../components";
import { Tabs } from "../../../components/tailwindComponent/ui/tabs";
import { ProcessBestPracticeHeader } from "../../../config/constants";
import { BestPracticeTabs } from "./BestPracticeTabs";

export function BestPracticeExplorer() {
  const [activeTab, setActiveTab] = useState("energy");
  const [selectItem, setSelectItem] = useState<any>();
  const location = useLocation();
  const useQuery = () => {
    return new URLSearchParams(location.search);
  };
  const query = useQuery();

  const salesUnitId = query.get("sourceId") || null;
  const productId = query.get("productId") || null;

  const { data: processData, isLoading: isLoadingProcessData } = useGetProcessData(
    salesUnitId,
    productId
  );

  const {
    data: wasteData,
    mutate: mutateWasteData,
    isLoading: isLoadingWasteData
  } = useGetWasteData();

  const mutationMap: any = {
    waste: mutateWasteData
  };

  useEffect(() => {
    const currentProcessData = processData?.[0] || null;
    setSelectItem(currentProcessData);
    const mutateFn = mutationMap[activeTab];
    if (mutateFn) {
      mutateFn({
        processGateId: currentProcessData?.key || ""
      });
    }
  }, [activeTab, processData]);

  const detailsSimulations = useMemo(() => {
    switch (activeTab) {
      case "energy":
        return [];
      case "water":
        return [];
      case "waste":
        return wasteData;
      case "chemicals":
        return [];
      case "yield":
        return [];
      default:
        return [];
    }
  }, [activeTab, JSON.stringify(wasteData)]);

  const selectNewProcessData = (processGateId: string) => {
    const currentProcessData = processData?.find((pd: any) => pd.value === processGateId) || null;
    setSelectItem(currentProcessData);
    const mutateFn = mutationMap[activeTab];
    if (mutateFn) {
      mutateFn({
        processGateId: currentProcessData?.key || ""
      });
    }
  };

  if (isLoadingWasteData || isLoadingProcessData) {
    return (
      <Dimmer active>
        <Loader content="Loading" />
      </Dimmer>
    );
  }

  return (
    <div className="w-full">
      <DropDown
        labelName="Process Name"
        placeholder="Select Process"
        currentData={processData || []}
        defaultValue={selectItem?.value}
        handleChangeState={(e, data) => {
          selectNewProcessData(data.value as string);
        }}
        onSearchChange={(e, data) => {}}
        search
      />
      <div className="mb-2">
        <div className="flex items-center gap-3">
          <div className="p-2 rounded-lg bg-processing/10">
            <Factory className="h-6 w-6 text-processing" />
          </div>
          <div>
            <h1 className="text-1xl font-bold text-foreground mb-0">Processing Best Practices</h1>
            <p className="text-muted-foreground text-lg">
              Quick simulations for energy, waste, water, chemicals, and yield optimization
            </p>
          </div>
        </div>
      </div>

      <Tabs value={activeTab} onValueChange={setActiveTab}>
        <BestPracticeTabs
          categories={ProcessBestPracticeHeader}
          activeTab={activeTab}
          detailedSimulations={detailsSimulations}
        />
      </Tabs>
    </div>
  );
}
